/**
 * Environment configuration for web app
 * Matches mobile app's environment.js patterns
 */

// Environment detection - matches mobile app logic
const getEnvironment = () => {
  // Check for explicit environment override first
  if (import.meta.env.VITE_API_ENV) {
    return import.meta.env.VITE_API_ENV;
  }
  
  // Check if we're in development mode
  if (import.meta.env.DEV) {
    return 'development';
  }
  
  // Default to production
  return 'production';
};

// Base URL configuration - matches mobile app patterns
const getApiBaseUrl = () => {
  // Check for explicit API URL override first (matches mobile's REACT_NATIVE_API_BASE_URL)
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // Use empty string for relative URLs - nginx will proxy /api/ to backend
  // This works for both development (Vite proxy) and production (nginx proxy)
  return '';
};

export const ENVIRONMENT = getEnvironment();
export const API_BASE_URL = getApiBaseUrl();

// Log configuration in development
if (import.meta.env.DEV) {
  // Configuration loaded
}